import React from "react"
import SmallInfo from "./small-info.component"
class SessionInfo extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      name,
      desc,
      ddValues,
      zoom,
      talent: {
        name: talentName,
        bio,
        instagram,
        primaryPhoto,
        secondaryPhoto,
      },
      slug,
      tools,
      length,
    } = this.props

    var sessionDate = new Date("December 10, 2020 12:00:00")
    // var todayDate = new Date()
    var todayDate = new Date("December 09, 2020 12:00:00")

    var isEventToday = false
    if (
      todayDate.getTime() === sessionDate.getTime() ||
      todayDate.getTime() > sessionDate.getTime()
    ) {
      isEventToday = true
    }

    return (
      <div className="session-info" data-aos="fade-left">
        <div className="session-info__top">
          <div className="session-info__text">
            <h1 className="session-info__text--heading">{name}</h1>
            <h4 className="session-info__text--subheading">{length}</h4>
            <p className="session-info__text--description">{desc}</p>

            <div className="session-info__time">
              <SmallInfo name="What to Bring" value={tools} />
            </div>

            <div className="session-info__values">
              <h4 className="small-info__heading">DoorDash Values</h4>
              {ddValues.map(value => (
                <p key={value} className="small-info__text">
                  {value}
                </p>
              ))}
            </div>

            {isEventToday ? (
              <div className="session-info__zoom">
                <a
                  className="session-info__zoom--button"
                  href={zoom}
                  target="_blank"
                >
                  JOIN NOW
                </a>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="session-info__image">
            <img src={`${slug}${primaryPhoto}`} alt="" />
          </div>
        </div>

        <div className="session-info__bottom">
          <div className="session-info__image">
            <img src={`${slug}${secondaryPhoto}`} alt="" />
          </div>

          <div className="session-info__text--right">
            <h1 className="session-info__text--heading--right">{talentName}</h1>

            {instagram.split(" ").map(insta => {
              if (insta != "") {
                const smallversion = insta.replace("@", "")
                const url = `https://www.instagram.com/${smallversion}`
                return (
                  <a href={`${url}`} target="_blank" key={insta}>
                    <h4 className="session-info__text--subheading">{insta}</h4>
                  </a>
                )
              }
            })}

            <p className="session-info__text--description">{bio}</p>
          </div>
        </div>
      </div>
    )
  }
}

export default SessionInfo
